import * as React from "react";
import {withRouter} from "react-router";
import {ConnectedListView} from "../../../advertisments/views/List";
import {RouterProps} from "../../../../../shared/ts/interfaces/router";
import {url} from "../../../../../shared/ts/helpers/routing";
import {CreationType} from "../../CreationType";


export const MonthlyCreationListView = withRouter(
    (props: RouterProps) => (
        <ConnectedListView
            additionalQuery={{type: CreationType.MONTHLY.toString()}}
            onItemClick={(id: number) => props.router.push(url("app:in:creation:monthly:edit", {id}))}
            addNewItemUrl="app:in:creation:monthly:add"
        />
    )
);
